var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.582 2.95281C8.583 5.77346 8.58399 8.58813 8.58499 11.3968C8.58499 11.6181 8.52868 11.8065 8.41605 11.962L6.14358 8.7775L0.00941293 0.0763449C0.00325813 0.0680444 -4.46e-05 0.0579709 4.54917e-07 0.0476375C4.55098e-05 0.0373042 0.00343692 0.0272588 0.00966386 0.0190123C0.0158908 0.0107658 0.024617 0.0047566 0.0345433 0.00188463C0.0444696 -0.00098735 0.0550606 -0.000567527 0.0647289 0.00308001L8.582 2.95281Z",
    fill: "#5672B6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.41589 11.962C8.52852 11.8065 8.58483 11.6181 8.58483 11.3968C8.58384 8.58815 8.58284 5.77348 8.58185 2.95283L10.198 2.38919L16.8465 0.0972831C17.0448 0.028511 17.0832 0.0798452 16.9616 0.251277C14.1967 4.14737 11.404 8.07485 8.58334 12.0337C8.55344 12.0756 8.49762 12.0517 8.41589 11.962Z",
    fill: "#0047AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/dropdown.5e722eef615a5c1ff4c6693c1d379ab6.svg";
export { ForwardRef as ReactComponent };